var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-shift-date"},[_c('p',{staticClass:"job-shift-date__label"},[_vm._v(_vm._s(_vm.$t(("jobDetail['" + _vm.type + "Date']"))))]),_vm._v(" "),_c('p',{staticClass:"job-shift-date__date"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }